// import React from "react";
// import { useState } from 'react'
// import Picker from 'react-mobile-picker'

// const selections = {
//   title: ['Mr.', 'Mrs.', 'Ms.', 'Dr.'],
//   firstName: ['John', 'Micheal', 'Elizabeth'],
//   lastName: ['Lennon', 'Jackson', 'Jordan', 'Legend', 'Taylor']
// }

// const SelectPicker = (selections) => {
//   const [pickerValue, setPickerValue] = useState({
//     title: 'Mr.',
//     firstName: 'Micheal',
//     lastName: 'Jordan'
//   })
//   selections = {};
//   return (
//     <Picker value={pickerValue} onChange={setPickerValue} wheelMode="natural">
//       {Object.keys(selections).map(name => (
//         <Picker.Column key={name} name={name}>
//           {selections[name].map(option => (
//             <Picker.Item key={option} value={option}>
//               {option}
//             </Picker.Item>
//           ))}
//         </Picker.Column>
//       ))}
//     </Picker>
//   );
// };

// export default SelectPicker;

import React, { useEffect, useState } from "react";
import Picker from "react-mobile-picker";

// Define your selection options for day, month, and year
const selections = {
  day: Array.from({ length: 31 }, (_, i) => (i + 1).toString()), // Days 1-31
  month: [
    { name: "January", value: "1" },
    { name: "February", value: "2" },
    { name: "March", value: "3" },
    { name: "April", value: "4" },
    { name: "May", value: "5" },
    { name: "June", value: "6" },
    { name: "July", value: "7" },
    { name: "August", value: "8" },
    { name: "September", value: "9" },
    { name: "October", value: "10" },
    { name: "November", value: "11" },
    { name: "December", value: "12" }
  ],
  year: Array.from({ length: 106 }, (_, i) => (2025 - i).toString()) // Years from 2025 to 1925
};

// Define the SelectPicker component
const SelectPicker = ({formData}) => {
  const [pickerValue, setPickerValue] = useState({
    day: "1",   // Default day
    month: "1",  // Default month value (January)
    year: "2025"  // Default year
  });

  useEffect(() => {
    if (formData) {
      setPickerValue({
        day: (formData.getDate()).toString(),
        month: (formData.getMonth() + 1).toString(), // Month is 0-indexed, so add 1
        year: formData.getFullYear().toString()
      });
    }
  }, [formData]);

  useEffect(() => {
    if (pickerValue) {
      setPickerValue({
        day: (formData.getDate()).toString(),
        month: (formData.getMonth() + 1).toString(), // Month is 0-indexed, so add 1
        year: formData.getFullYear().toString()
      });
    }
  }, [pickerValue]);

  // Function to handle month change and update value
  const handleMonthChange = (name, value) => {
    setPickerValue(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <Picker value={pickerValue} onChange={setPickerValue} wheelMode="natural">
      {Object.keys(selections).map(name => (
        <Picker.Column key={name} name={name}>
          {selections[name].map(option => (
            <Picker.Item
              key={option.name || option}
              value={option.value || option}
            >
              <p className={pickerValue.day === option || pickerValue.month === option.value || pickerValue.year === option ? 'date-item selected' : 'date-item'}>{option.name || option}</p>
            </Picker.Item>
          ))}
        </Picker.Column>
      ))}
    </Picker>
  );
};

export default SelectPicker;
